export const SET_BUNDLE_ID = "SET_BUNDLE_ID";
export const SET_FCM_KEY = "SET_FCM_KEY";

export const SET_APP_LOADING = "SET_APP_LOADING";
export const SET_APP_ERROR = "SET_APP_ERROR";
